module.exports = __webpack_public_path__ + "static/img/activity-scene-3.51e598e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-scene-3.jpg
// module id = S+lm
// module chunks = 10